
/* @ngInject */
function AuditListItemController ($scope, $q, ModalService) {
  const getAuditDetailDialogController = () => $q.when(import('../../dialogs/audit-detail/audit-detail-dialog.controller'))

  const api = {
    getAuditDetailDialogController
  }
  this.getApi = () => api

  $scope.handleAuditClick = function (id) {
    api.getAuditDetailDialogController().then(({ AuditDetailDialogController }) => {
      ModalService.showModal({
        controller: AuditDetailDialogController,
        templateId: 'auditDetail.html',
        templateUrl: '/audit/dialogs/audit-detail/audit-detail-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        data: {
          id: id
        }
      }).then(options => {
        if (options && options.wasDeleted) {
          $scope.$emit('reloadAudits')
        } else if (options && options.wasUpdated) {
          $scope.audit = options.audit
          $scope.audit.updatedAt = new Date().toISOString()
        }
      })
    })
  }
}

export { AuditListItemController }
